import Config from '@/utils/config'
import { CustomApi } from './custom-api'
import { StorageKeys } from '@/utils/constants'

const WBDApi = new CustomApi({
  baseUrl: Config.API_URL,
  securityWorker: (data) => {
    return {
      headers: {
        Authorization: `Bearer ${data?.token}`
      }
    }
  }
})

if (typeof localStorage !== 'undefined') {
  const token = localStorage.getItem(StorageKeys.ACCESS_TOKEN)
  WBDApi.setSecurityData({ token })
}

export { WBDApi }
